module.exports = __webpack_public_path__ + "static/media/testimonial-1.283b1e8d.jpg";